import * as React from "react";

const EnterMemberData = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <rect width={32} height={32} fill="#fff" fillOpacity={0.08} rx={16} />
    <mask
      id="EnterMemberData"
      width={20}
      height={20}
      x={6}
      y={6}
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
    >
      <path fill="#D9D9D9" d="M6 6h20v20H6z" />
    </mask>
    <g mask="url(#EnterMemberData)">
      <path
        fill="#EAF2FF"
        d="M15.167 11.333v4.167H11v1.667h4.167V21.333h1.666v-4.166H21v-1.667h-4.167v-4.167h-1.666Z"
      />
    </g>
  </svg>
);

export default EnterMemberData;
